import * as React from "react";
import { Component } from "react";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import HeroBackground1 from "../../images/hero-background-1.png";
import HeroBackground1Mobile from "../../images/hero-background-1-mobile.png";
import WhatWeLiveFor from "../../images/what-we-live-for.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import HeroBlindAngels from "../../images/homepage-blind-angels-hero.png";
import HeroBlindAngelsMobile from "../../images/homepage-blind-angels-hero-mobile.png";

class HeroCarousel extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
  }
  handleClose = (show) => {
    this.setState({ show: false });
  };
  handleClose = (show) => {
    this.setState({ show: false });
  };
  handleShow = (show) => {
    this.setState({ show: true });
  };
  render() {
    return (
      <Container className="px-0">
        <Row>
          <Col>
            <Carousel interval={7000} keyboard={true}>
              <Carousel.Item>
                <img
                  className="d-none d-md-block w-100"
                  src={"/putting-into-practice-hero.png"}
                  alt="USCHA 2023"
                />
                <img
                  className="d-block d-md-none w-100"
                  src={"/putting-into-practice-hero-mobile.png"}
                  alt="USCHA 2023"
                />

                <Carousel.Caption className="prep-matters">
                  <Container>
                    <Row className="h-100">
                      <Col
                        xs={{ span: 7 }}
                        sm={{ span: 8 }}
                        md={{ span: 6, offset: 1 }}
                        className="pl-2 px-md-0"
                      >
                        <a className="no-interstitial nodecor">
                          <div className="cont-slide">
                            <h2 className="font-heavy line-height-25-mob d-none d-lg-block">
                            PrEP Matters: <span className="no-break">A Guide</span> to Advancing Uptake
                            </h2>
                            <h2 className="font-heavy line-height-25-mob d-lg-none">
                            PrEP Matters: A Guide to Advancing Uptake for Allied Healthcare Professionals
                            </h2>
                            <p className="d-none d-lg-block">
                            Explore this downloadable resource for allied healthcare professionals on advancing <span className="no-break">pre-exposure</span> prophylaxis (PrEP) uptake at the moment of HIV and STI testing.
                            </p>
                            <a
                              className="slide-anchor open_isi"
                              href="/downloadable-resource/prep-basics"
                            >
                              <span className="btn red text-uppercase">
                                Learn More
                              </span>
                            </a>
                          </div>
                        </a>
                      </Col>
                    </Row>
                  </Container>
                </Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-none d-md-block w-100"
                  src={"/hall-of-femme-hero-desktop.jpg"}
                  alt="Hall of Femme"
                />
                <img
                  className="d-block d-md-none w-100"
                  src={"/hall-of-femme-hero-mobile.jpg"}
                  alt="Hall of Femme"
                />
                <Carousel.Caption className="slide-2">
                  <Container className="h-100">
                    <Row className="h-100">
                      <Col
                        xs={{ span: 12, offset: 0 }}
                        md={{ span: 5, offset: 8 }}
                        className="px-0"
                      >
                        <a
                          className="no-interstitial nodecor"
                          href="../../championsofchange/"
                        >
                          <div className="cont-slide">
                            <h2 className="font-heavy line-height-25-mob text-uppercase">
                              Champions of Change: A Celebration of Black Women
                              Changemakers in&nbsp;HIV
                            </h2>
                            <p className="d-none d-lg-block">
                              Gilead is proud to launch a new tribute that
                              honors 10 Black women leaders in HIV. The tribute
                              provides a much-needed spotlight on the monumental
                              work these visionaries are doing to change the
                              course of the HIV epidemic.
                            </p>
                            <a
                              className="slide-anchor open_isi"
                              href="/championsofchange/"
                            >
                              {/*<span className="btn red text-uppercase d-none d-sm-inline">
                                Learn More <br className="d-block d-md-none"/>
                              </span>*/}
                              <span className="btn red text-uppercase">
                                Meet the Honorees
                              </span>
                            </a>
                          </div>
                        </a>
                      </Col>
                    </Row>
                  </Container>
                </Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-none d-md-block w-100"
                  src={"/hiv-community-collaborations-hero.png"}
                  alt="Together we can help end the HIV epidemic for everyone, everywhere"
                />
                <img
                  className="d-block d-md-none w-100"
                  src={"/hiv-community-collaborations-hero-mobile.png"}
                  alt="Together we can help end the HIV epidemic for everyone, everywhere"
                />
                <Carousel.Caption className="slide-0">
                  <Container>
                    <Row>
                      <Col
                        xs={{ span: 9, offset: 1 }}
                        md={{ span: 6, offset: 1 }}
                        className="px-0"
                      >
                        <a className="no-interstitial nodecor">
                          <div className="cont-slide mt-20">
                            <h2 className="font-heavy line-height-25-mob">
                              Together we can help end the HIV epidemic for
                              everyone, everywhere.
                            </h2>
                            <p className="subtext d-none d-lg-block">
                              Gilead is proud to support organizations and
                              advocates across the country who are working every
                              day to improve health equity and bring awareness
                              to HIV in their local communities. From Florida to
                              San Francisco, Mississippi to Texas, this is the
                              work that inspires us.
                            </p>
                            <a
                              className="slide-anchor open_isi"
                              href="/community-involvement/community-commitments/"
                            >
                              <span class="btn red">
                                EXPLORE OUR <br class="d-block d-md-none" />
                                COLLABORATIONS
                              </span>
                            </a>
                          </div>
                        </a>
                      </Col>
                    </Row>
                  </Container>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default HeroCarousel;
